import React from 'react';
import ThumbsUp from '@johnlewispartnership/wtr-ingredients/dist/Icon/ThumbsUp';
import Typography from '@johnlewispartnership/wtr-ingredients/foundations/typography';
import styles from './index.module.scss';
const ThankYouMessage = () => (React.createElement("div", { className: styles.container, "data-testid": "thank-you-message" },
    React.createElement(ThumbsUp, { className: styles.icon }),
    React.createElement("div", { className: styles.header },
        React.createElement(Typography, { styleAs: "sectionHeadingLight", noMargins: true }, "Thank you.")),
    React.createElement(Typography, { noMargins: true }, "Your feedback is important and helps us to improve.")));
export default ThankYouMessage;
//# sourceMappingURL=index.js.map